import React, { useState } from 'react'
import { useTranslation } from "react-i18next"
import { Subheader } from '../../../components/Page/logix2020/Subheader'
import { FlexWrapper } from '../../../components/Page/logix2020/FlexWrapper'
import { SidebarLeft } from '../../../components/Page/logix2020/SidebarLeft'
import AdministrationSidebarNavigation from '../../../components/Configuration/AdministrationSidebarNavigation'
import { ContentArea } from '../../../components/Page/logix2020/ContentArea'
import { useObserver } from 'mobx-react'
import useStores from '../../../stores/useStore'
import { Alert, Spinner, Form } from 'react-bootstrap'
import { ExcelButton } from '../../../components/Buttons/ExcelButton'
import CreateNewImportOverlay from '../../../components/Files/CreateNewImportOverlay'
import CreateNewExportOverlay from '../../../components/Files/CreateNewExportOverlay'
import ArticlesTable from '../../../components/Configuration/Articles/ArticlesTable'
import { useArticlesState } from '../../../stores/Configuration/ArticlesProvider'
import styled from 'styled-components'

const StyledWrapper = styled.div`
  .form-label {
    white-space: nowrap;
  }
`
const StyledSwitch = styled.div`
  font-weight: bold;
  display: flex;
  flex-direction: row-reverse;
`
const ArticlesAdministrationPage = () => {
  const {
    setSelectedRow,
    setFilter, filter
  } = useArticlesState()
  const { t } = useTranslation()
  const { uiStore } = useStores()
  const allowImportArticles = useObserver(() => uiStore.allowImportArticles)
  const onlyAccessTolocalArticles = useObserver(() => uiStore.onlyAccessTolocalArticles)
  const dashboardIsLoading = useObserver(() => uiStore.dashboardIsLoading)
  const dashboardLoaded = useObserver(() => !!uiStore.dashboard)
  const [showExportOverlay, setShowExportOverlay] = useState(false)
  const [showImportOverlay, setShowImportOverlay] = useState(false)

  const onCloseOverlayClick = () => {
    setShowExportOverlay(false)
    setShowImportOverlay(false)
  }
  const onRowClick = (e, row) => {
    setSelectedRow(prev => prev === row ? false : row)
  }
  const renderSelectTemplates = () => {
    return (
      <>
        <StyledWrapper className="spacing-down">
        <StyledSwitch>
          <Form.Check
            type="switch"
            id="custom-switch"
            name="templateArticles"
            label={t('articleAdmin:templateArticle')}
            onChange={e => setFilter(prev => ({
              ...prev,
              'filter.templateArticles': e.target.checked ? true : '',
            }))}
            checked={filter['filter.templateArticles']}
          />
          </StyledSwitch>
        </StyledWrapper>
      </>
    )
  }
  return (
    <>
      <Subheader className="subHeader-v1">
        <div className="subheader-title flex-grow-1">{t('articleAdmin:articleHeader')}</div>
        <div className="subheader__buttonWrapper">
          {(allowImportArticles && !onlyAccessTolocalArticles) &&
            <>
            <ExcelButton onClick={() => setShowImportOverlay(prev => !prev)} className="subheader__button" variant="secondary" buttonText={t('import')} />
            <ExcelButton onClick={() => setShowExportOverlay(prev => !prev)} className="subheader__button" variant="secondary" buttonText={t('export')} />
            </>
          }         
        </div>
      </Subheader>
      <FlexWrapper>
        <SidebarLeft>
          <AdministrationSidebarNavigation active="articlesAdministration" />
        </SidebarLeft>
        <ContentArea>
        {renderSelectTemplates()}
          {allowImportArticles ?
            <ArticlesTable onRowClick={onRowClick} tableId="Articles" />
            : (dashboardIsLoading || dashboardLoaded)
              ? <div className="d-flex align-items-center justify-content-center"><Spinner animation='border' variant='primary' /></div>
              : <Alert variant='danger'>{t('accessDenied')}</Alert>
          }
        </ContentArea>
      </FlexWrapper>
      <CreateNewExportOverlay exportName="articleExport" visible={showExportOverlay} onClose={onCloseOverlayClick} />
      <CreateNewImportOverlay importName="articleImport" visible={showImportOverlay} onClose={onCloseOverlayClick} />
    </>
  )
}

export default ArticlesAdministrationPage